<template>
  <div id="head-info">
    <div class="info">
      <div class="display1">黄江涛</div>
      <div class="body-1">重庆渝北 | 1998年 | 4年工作经验 | WEB前端 | Flutter | 12K~14K | 重庆机电职业技术大学专科</div>
      <p>使用 VUE 套件开发过 8 个项目、Flutter 开发过 4 个项⽬、android 开发过 2 个项目。熟悉并使用过 React、Python、PHP 进行小项目开发。爱好写 Blog 。</p>
      <div class="body-1">
        联系方式：<a href="tel:17623142556">17623142556</a> & <a href="mailto:jethro2019x@outlook.com">jethro2019x@outlook.com</a>
      </div>
      <div class="body-1">主页：<a href="http://juejin.jethro.fun/" target="_blank">http://juejin.jethro.fun</a></div>
      <div class="body-1">作品集：
        <router-link to="sample">{{domain}}/#sample</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeadInfo',
  data () {
    return {
      domain: ''
    }
  },
  created () {
    this.domain = location.origin
  }
}
</script>

<style scoped lang="less">
@import "../common";

@headSize: 80px;
#head-info {
  padding: @padding @padding4x @padding @padding4x;

  .info {
    padding-right: 16px;
  }

  .head {
    width: @headSize;
    height: @headSize;
    border: 4px solid #e0e0e0;
    margin-top: 8px;
  }
}
</style>
